/** Customer account-management application entry point. */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AccountApp } from "./AccountApp";

const elem = document.getElementById("account-root")!;
const app = (
  <StrictMode>
    <AccountApp />
  </StrictMode>
);

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  createRoot(elem).render(app);
}
